// Error layer – lokální chybová vrstva s close-only recovery

import { useTranslation } from 'react-i18next';
import type { LayerDescriptor } from '../core/layerDescriptor';
import { useNavigationContext } from '../react/useNavigationContext';

interface NavigationErrorLayerProps {
  layer: LayerDescriptor;
}

/**
 * Zobrazuje lokální error layer pro nevalidní vrstvu.
 * Nabízí zavření vrstvy – close-only recovery.
 */
export function NavigationErrorLayer({ layer }: NavigationErrorLayerProps) {
  const { t } = useTranslation('navigation');
  const { kernel } = useNavigationContext();

  const errorReason = layer.errorReason;

  return (
    <div className="flex flex-col items-center gap-4 p-8 text-center" role="alert">
      <h2 className="text-destructive text-lg font-semibold">{t('navigation.error.title')}</h2>

      <p className="text-muted-foreground">
        {errorReason?.code === 'UNKNOWN_AGENDA'
          ? t('navigation.error.unknownAgenda', { agendaId: errorReason.agendaId })
          : errorReason?.code === 'INVALID_PARAMS'
            ? t('navigation.error.invalidParams', { agendaId: errorReason.agendaId })
            : errorReason?.code === 'DECODE_ERROR'
              ? t('navigation.error.invalidParams', { agendaId: errorReason.agendaId })
              : t('navigation.error.invalidLayer')}
      </p>

      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => kernel.closeLayer(layer.layerId)}
          className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-4 py-2 transition-colors"
          data-testid="error-layer-close"
        >
          {t('navigation.error.close')}
        </button>
      </div>
    </div>
  );
}
